import * as React from "react";
import styled from "styled-components";
import { useStore } from "@/lib/storeData/StoreContext";
import { themeColor } from "@/shared/styles-utils";
import ItemImg from "@/shared/globals/UiElements/ItemImg";
import { LogoSizes } from "@/shared/globals/types";
import { LogoSize } from "@/generated/graphql";
import { Link } from "@/i18n/i18n-navigation";
import { getStoreLink } from "@/shared/utils/shinglePageCheckoutFunctions";
import { useLocale } from "@/i18n/i18n-client";

export interface LogoProps {
  logoSize?: LogoSize;
}

const Logo: React.FC<LogoProps> = ({ logoSize }) => {
  const { logo, name, WuiltPayState, handle, domain } = useStore();
  const locale = useLocale();

  const content = logo?.image?.src ? (
    <LogoWrapper>
      <ItemImg
        imgDetails={logo?.image}
        onlyImg
        size={LogoSizes[logoSize || logo?.size || LogoSize.Medium]}
        innerSize={LogoSizes[logoSize || logo?.size || LogoSize.Medium]}
        isSquare={false}
      />
    </LogoWrapper>
  ) : (
    <span>{name}</span>
  );
  return (
    <Link
      href={
        WuiltPayState?.enabled
          ? getStoreLink({
              storeHandle: handle,
              storeDomain: domain?.domainName,
              locale: locale?.code,
            })
          : "/"
      }
      passHref
    >
      <StyledSpan data-test="store-logo">{content}</StyledSpan>
    </Link>
  );
};

export default Logo;

/**
 *
 * Styles
 *
 */

const LogoWrapper = styled.div`
  > div {
    height: unset;
    &::after {
      padding-bottom: 0;
    }
  }
`;

const StyledSpan = styled.span`
  display: flex;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.6;
  text-decoration: none;
  color: ${themeColor("primary")};
`;
